'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userDetails = require('./user-details.html');

var _userDetails2 = _interopRequireDefault(_userDetails);

var _userDetails3 = require('./user-details.controller');

var _userDetails4 = _interopRequireDefault(_userDetails3);

require('./user-details.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template: _userDetails2.default,
  controller: _userDetails4.default,
  controllerAs: 'vm'
};

exports.default = userDetailsComponent;


/** WEBPACK FOOTER **
 ** ./client/app/containers/user-details/user-details.component.js
 **/